import React, { Component } from 'react'

import './Footer.css';
import iAdvizeWhiteLogo from '../Icons/iadvize-white-logo.svg';


class Footer extends Component {

  render() {
    return (
      <footer>
        <div className="logo">
          <img src={iAdvizeWhiteLogo} alt="iAdvize logo" />
        </div>
        <ul className="contacts">
          <li>
            Technical issue?
            <br/>
            <b><a href="https://help.app.idzhq.com/" target="_blank" rel="noopener noreferrer">Contact IS Department</a></b>
          </li>
          <li>
            General question about cagnottes?
            <br/>
            <b><a href="https://mail.google.com/mail/u/0/?compose=0&view=cm&fs=1&to=miranda.hobbs@iadvize.com&su=Question%20about%20Backon&tf=1" target="_blank" rel="noopener noreferrer">Contact Miranda Hobbs</a></b>
          </li>
          <li>
            Payment or refund issue?
            <br/>
            <b><a href="https://mail.google.com/mail/u/0/?compose=0&view=cm&fs=1&to=ismahan.grosboismoreau@iadvize.com&su=Issue%20with%20Backon&tf=1" target="_blank" rel="noopener noreferrer">Contact Ismahan Grosbois-Moreau</a></b>
          </li>
        </ul>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js